import { IataCountry } from '../../iata/objects/iataCountry';
import { ClientQuotationIncludedPermission } from '../../quotationIncludedPermission/objects/quotationIncludedPermission';
import { Picture } from '../../picture/objects/picture';
import { Settlement } from '../../settlement/objects/settlement';
import { Trip } from '../../trip/objects/trip';
import { Author } from '../../user/objects/author';
import { CentralPayment } from './../../centralPayment/objects/centralPayment';
import { Column } from './column';
import { DeleteItem } from './deteItem';
import { Domain } from './domain';
import { OrganisationEditStep } from './editStep';
import { GroupMinimal } from './groupMinimal';
import { MailHistory } from './mailHistory';
import { Network } from './network';
import { Organisation } from './organisation';
import { OrganisationComment } from './organisationComment';
import { OrganisationContact } from './organisationContact';
import { OrganisationContactErrors } from './organisationContactErrors';
import { OrganisationHistTrip } from './organisationHistTrip';
import { OrganisationInvoice } from './organisationInvoice';
import { OrganisationNote } from './organisationNote';
import { OrganisationRubricConfiguration } from './organisationRubricConfiguration';
import { OrganisationTripListConfiguration } from './organisationTripListConfiguration';
import { OrganisationTripListCriteria } from './organisationTripListCriteria';
import { Locale } from '../../locale/objects/locale';
import { RevisionHistory } from './organisationRevisionHistory';
import { Margin } from '../../margin/objects/margin';
import { MarginListCriteria } from './marginListCriteria';
import { Commercial } from '../../commercial/objects/commercial';
import { Brand } from '../../site/objects/brand';
import { PaymentPolicy } from './paymentPolicy';
import { Currency } from '../../currency/objects/currency';


export enum PreferredPaymentChoices {
    TRANSFER = "TRANSFER",
    WITHDRAWAL = "WITHDRAWAL",
    VOUCHER = "VOUCHER",
    CB = "CB"
}
export enum BillingMethod {
    AUTOMATIC = "AUTOMATIC",
    MANUAL = "MANUAL"
}
export interface OrganisationState {
    activated_locales: Locale[];
    address: string;
    longitude: string;
    latitude: string;
    google_id: string;
    zoom: number;
    city: string;
    branch_code: string | null;
    additional_branch_codes: string[] | null;
    is_organisation_location_edit_open: boolean;
    allow_margin: boolean;
    allow_margin_error: string;
    can_edit_quotation_included: ClientQuotationIncludedPermission;
    columns: Column[];
    complementary_address: string;
    count: number;
    country: null | IataCountry;
    create: boolean;
    created_date: null | string;
    creator: null | Author;
    delay_payment: string;
    delay_payment_error: string;
    domain: Domain | null;
    delete_organisation: null | Organisation;
    edit_step: OrganisationEditStep;
    edit_info: boolean;
    email: string;
    editing_field: keyof Organisation | '' | 'commercials';
    email_error: string;
    phone_number_error: string;
    export_full: boolean;
    export_list: boolean;
    export_type: 'CSV' | 'PDF';
    filter_creator: string;
    filter_last_author: string;
    filter_network: null | Network;
    filter_brands: string[],
    filter_open: boolean;
    filter_vat_number: string;
    filter_external_id: string;
    filter_commercials: Commercial[];
    filter_city: string;
    filter_groups: Network[];
    filter_sub_nets: Network[];
    filter_mini_networks: Network[];
    id: null | number;
    last_author: null | Author;
    limit: number;
    list: null | Organisation[];
    logo: null | Picture;
    logo_error: string;
    logo_progress: number;
    modified_date: null | string;
    name: string;
    name_error: string;
    corporate_name_of_agency_error: string;
    group: null | Network | GroupMinimal; //TODO: group object type
    sub_net: null | Network;
    mini_network: null | Network;
    group_error: string;
    group_paying: boolean;
    group_paying_error: string;
    order: 'asc' | 'desc';
    order_by: string;
    organisation: null | Organisation;
    page: number;
    paiement_delay: string;
    paiement_delay_error: string;
    phone_number: string;
    postal_code: string;
    postal_code_error: string;
    quota: number | string;
    quota_error: string;
    refresh: boolean;
    running: boolean;
    search: string;
    siret: string;
    street: string;
    type: 1 | 2 | 3;
    type_error: string;
    vat_number: string;
    tier_code: string;
    zip_code: string | null;
    zip_code_error: string;
    notes: OrganisationNote[];
    notes_loading: boolean;
    comments: OrganisationComment[];
    comments_loading: boolean;
    contacts_create: (OrganisationContact & OrganisationContactErrors)[];
    contacts: OrganisationContact[];
    contacts_loading: boolean;
    delete_item: DeleteItem | null;
    external_id: number | string;
    is_blocked: boolean;
    is_active: boolean;
    internal_note: null | string;
    usual_name: string;
    account: string;
    orchestra_id: string;
    rubrics_configuration: OrganisationRubricConfiguration;
    hist_trips: OrganisationHistTrip[],
    hist_trips_loading: boolean,
    email_loading: boolean,
    trip_list: Trip[];
    trip_list_configuration: OrganisationTripListConfiguration;
    trip_list_loading: boolean;
    trip_list_count: number;
    trip_list_criteria: OrganisationTripListCriteria;
    central_payment: null | CentralPayment;
    due_date: Settlement | null;
    due_date_error: string;
    origin_due_date: 'network' | 'network_payment_center' | 'client_payment_center' | 'client' | null;
    email_history: MailHistory[];
    email_history_loading: boolean;
    invoice_credential: null | { invoice: OrganisationInvoice, trip: Trip };
    invoice_list: OrganisationInvoice[] | null,
    trip_open_id: number | null,
    contact_emails: string[];
    phone_numbers: string[];
    corporate_name_of_agency: string;
    Accounting_e_mails: string[];
    preferred_payment_method: PreferredPaymentChoices;
    billing_method: BillingMethod;
    allow_mailing: boolean;
    allow_phoning: boolean;
    allow_emailing: boolean;
    allow_smsing: boolean;
    unsubscribe_from_newsletter: boolean;
    third_party_account_number: string;
    revision_history: RevisionHistory[];
    margins_configuration: OrganisationTripListConfiguration;
    margins: Margin[];
    margins_loading: boolean;
    margins_count: number;
    margins_criteria: MarginListCriteria;
    margin: Margin | null;
    suspended_margin: Margin | null;
    refresh_margin_list: boolean;
    commercials: Commercial[];
    first_preference_loaded: boolean;
    brands: string[];
    payment_policy: PaymentPolicy;
    currencies: Currency[];
    payment_details_view: 'credit_line' | 'wallet' | 'onetime_overflow' | null;
}
